export default {
  quotes: [
    {
      id: 'stephanie',
      quote: '“Great colors, super soft fabric...styles you can’t find anywhere else!” - Stephanie',
      name: 'Stephanie'
    },
    {
      id: 'hollie',
      quote: '“The cutest and most unique clothes! Obsessed!” - Hollie',
      name: 'Hollie'
    },
    {
      id: 'allison',
      quote: '“All of the designs are unique and thoughtful. Wish they made mom clothes too!” - Allison',
      name: 'Allison'
    }
  ],
}



// WEBPACK FOOTER //
// ./src/components/textCarousel/defaultProps.js